import React from 'react'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import { cl1, closeIcon1, myjobs, profileLogo } from '../../Constant'

function MyJobs() {
  return (
    <>
    <Header />
            <section className="servcies py-10" 
             style={{ backgroundImage: `url(${myjobs})` }} 
                >
        <div className="container hero supplement ">
            <div className="row">
                <div className="col-md-6 py-10">
                    <h1 className="white">My Jobs</h1>
                    <p className="white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                        incididunt ut labore et dolore magna aliqua. . </p>
                </div>
                <div className="col-md-6"></div>
            </div>
        </div>
    </section>
   
    <section className="jobs">
        <div className="container">
            <div className="row ">
                <div className="col-md-2">
                    <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example">
                        <option selected>Choose Location</option>
                        <option value="1">USA</option>
                        <option value="2">UK</option>
                        <option value="3">Germany</option>
                    </select>
                </div>
                <div className="col-md-2 border-left">
                    <select className="form-select form-select-lg mb-3 " aria-label=".form-select-lg example">
                        <option selected>Salary Range</option>
                        <option value="1">$1000</option>
                        <option value="2">$5000</option>
                        <option value="3">$10000</option>
                    </select>
                </div>
                <div className="col-md-8 border-left">
                    <div className="input-group">
                        <input type="text" className="form-control" placeholder="Search jobs title here..." />
                        <div className="input-group-append">
                            <button className="btn btn-secondary" type="button">
                                Search <i className="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section className="result" style={{paddingBottom:"0px"}}>
            <div className="container">
                <div className="row">
                    <div className="col-md-9">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="records"><b>Showing 12 of 124 Jobs Results:</b> <br /><span>Based your
                                    preferences</span>
                                </div>
                            </div>
                            <div className="col-md-1 ">
                                <button type="button" className="btn btn-soft-base btn-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                         stroke-linejoin="round" className="feather feather-list">
                                        <line x1="8" y1="6" x2="21" y2="6"></line>
                                        <line x1="8" y1="12" x2="21" y2="12"></line>
                                        <line x1="8" y1="18" x2="21" y2="18"></line>
                                        <line x1="3" y1="6" x2="3" y2="6"></line>
                                        <line x1="3" y1="12" x2="3" y2="12"></line>
                                        <line x1="3" y1="18" x2="3" y2="18"></line>
                                    </svg>
                                </button>
                            </div>
                            <div className="col-md-1">
                                <button type="button" className="btn btn-soft-base btn-icon orange">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                         stroke-linejoin="round" className="feather feather-grid">
                                        <rect x="3" y="3" width="7" height="7"></rect>
                                        <rect x="14" y="3" width="7" height="7"></rect>
                                        <rect x="14" y="14" width="7" height="7"></rect>
                                        <rect x="3" y="14" width="7" height="7"></rect>
                                    </svg>
                                </button>
                            </div>
                            <div className="col-md-2 ">
                                <select className="form-select form-select-lg mb-3 select1" aria-label=".form-select-lg example">
                                    <option selected>Newest</option>
                                    <option value="1">Oldest</option>
                                    <option value="2">A-Z</option>
                                    <option value="3">Z-A</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="row">
                            <div className="col-md-12">
                                <p href="#">Job Preview<span className="float-right">
                                    <a href="#">
                                    <img src={closeIcon1} />
                                    </a>
                                    </span>
                                    </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                            </div>
                        </div>
                    </div>
                </div>
                </div>
        </section>
        <section>
            <div className="container">
                <div className="row">
                    <div className="col-md-9">
                        <div className="row py-2">
                            <div className="col-sm-6 col-lg-3 m-15 px-tb">
                                <div className="job-item  box-shadow-only-hover hover-top border-all-1 border-color-gray py-3">
                                    <div className="item-overlay ">
                                        <div className="job-info text-center">
                                            <img src={cl1} alt="" />
                                            <div className="text-center py-3">
                                                <h5><a href="#" className="grey">Consectetur</a></h5>
                                                <h6><a className="orange" href="#">Bubbles Studios</a></h6>
                                            </div>
                                           
                                         
                                        </div>
                                        <ul className="tr-list job-meta list-unstyled job-social tr-list">
                                            <li><i className="fa fa-map-marker" aria-hidden="true"></i> Manchester, England
                                            </li>
                                            <li><i className="fa fa-money" aria-hidden="true"></i> $ 2,000 - $ 2,500</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-3 m-15 px-tb">
                                <div className="job-item  box-shadow-only-hover hover-top border-all-1 border-color-gray py-3">
                                    <div className="item-overlay ">
                                        <div className="job-info text-center">
                                            <img src={cl1} alt="" />
                                            <div className="text-center py-3">
                                                <h5><a href="#" className="grey">Consectetur</a></h5>
                                                <h6><a className="orange" href="#">Bubbles Studios</a></h6>
                                            </div>
                                           
                                        </div>
                                        <ul className="tr-list job-meta list-unstyled job-social tr-list">
                                            <li><i className="fa fa-map-marker" aria-hidden="true"></i> Manchester, England
                                            </li>
                                            <li><i className="fa fa-money" aria-hidden="true"></i> $ 2,000 - $ 2,500</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-3 m-15 px-tb">
                                <div className="job-item  box-shadow-only-hover hover-top border-all-1 border-color-gray py-3">
                                    <div className="item-overlay ">
                                        <div className="job-info text-center">
                                            <img src={cl1} alt="" />
                                            <div className="text-center py-3">
                                                <h5><a href="#" className="grey">Consectetur</a></h5>
                                                <h6><a className="orange" href="#">Bubbles Studios</a></h6>
                                            </div>
                            
                                        </div>
                                        <ul className="tr-list job-meta list-unstyled job-social tr-list">
                                            <li><i className="fa fa-map-marker" aria-hidden="true"></i> Manchester, England
                                            </li>
                                            <li><i className="fa fa-money" aria-hidden="true"></i> $ 2,000 - $ 2,500</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 box-shadow-only-hover hover-top ">
                        <div className="card profile ">
                            <div className="card-body box-blue">
                                <div className="d-flex flex-column align-items-center ">
                                    <div className="img-back"></div>
                                    <img src={profileLogo} alt="Admin" className="text-center " width="150" />
                                    <div className="mt-3">
                                        <h4 className="text-center">Lorem Ipsum</h4>
                                        <p className="text-secondary mb-1 orange text-center">Bubbles Studios</p>
                                        <ul className="tr-list job-meta list-unstyled job-social tr-list ul-color">
                                            <li> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                                tempor incididunt ut labore
                                            </li>

                                        </ul>

                                        <div className="j-list">
                                            <ul className="tr-list job-meta list-unstyled job-social tr-list ul-color">
                                                <li><i className="fa fa-star " aria-hidden="true"></i> Tempor incididunt ut
                                                    labore
                                                </li>
                                                <li><i className="fa fa-star " aria-hidden="true"></i> Lorem ipsum dolor
                                                </li>
                                                <li><i className="fa fa-star " aria-hidden="true"></i> Sit amet consectetur
                                                </li>
                                                <li><i className="fa fa-star " aria-hidden="true"></i> Labore adipsicans elit do uasde
                                                </li>
                                            </ul>
                                        </div>

                                        <ul className="tr-list job-meta list-unstyled job-social tr-list ul-color">
                                            <li><i><img src="img/jobs/location-icon.png" alt="Admin" width="30" /></i>
                                                Manchester, England
                                            </li>
                                            <li>
                                                <i>
                                                    <img src="img/jobs/dollar-icon.png" alt="Admin" width="30" />
                                                </i> $ 2,000 -
                                                $ 2,500
                                            </li>
                                        </ul>

                                        <button className="btn btn-jobs">APPLY JOB</button>
                                        <a style={{marginleft:"10px"}} href="#">
                                            <img src="img/btn-profile.png" alt="Admin" width="75" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      
            <nav className="d-flex justify-content-center">
                <ul className="pagination pagination-base pagination-boxed pagination-square mb-0">
                    <li className="gap">
                        <a className=" no-border btn btn-outline " href="#">
                            <span aria-hidden="true">Prev</span>
                            <span className="sr-only">Previous</span>
                        </a>
                    </li>
                    <li className="page-item active"><a className="page-link no-border" href="#">1</a></li>
                    <li className="page-item"><a className="page-link no-border" href="#">2</a></li>
                    <li className="page-item"><a className="page-link no-border" href="#">3</a></li>
                    <li className="page-item"><a className="page-link no-border" href="#">4</a></li>
                    <li className="gap">
                        <a className=" no-border btn btn-outline" href="#">
                            <span aria-hidden="true">Next</span>
                            <span className="sr-only">Next</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </section>
    </section>
    <Footer />
    </>
  )
}

export default MyJobs